import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";
import ResmedSignIn from "src/containers/SignInPage/ResmedSignIn";
import AuthService from "src/services/authService";
import { injectAuthUser } from "src/store/actions/auth";

import HeaderBar from "@containers/HeaderBar";

import Login from "@pages/Login";
import PasswordReset from "@pages/PasswordReset";
import PatientDetailsPage from "@pages/PatientDetailsPage";
import Register from "@pages/Register";
import CompleteProfile from "@pages/CompleteProfile";

import { getRecordId } from "@utils/helpers";

import { IAppState } from "../store/reducers";
import { AuthState } from "../store/reducers/auth";
import { ConditionalAuthGuard } from "./components/Auth/ConditionalAuthGuard";
import { PatientDashboard, PatientFormPage } from "./pages";
import MoveUpAppointmentPage from "./pages/MoveUpAppointmentPage";
import FormCompletionPage from "./pages/PatientForms/FormCompletionPage";

const ProtectedRoute: React.FC<RouteProps> = ({ component: Component, ...rest }) => {
  const { authUser: user } = useSelector<IAppState, AuthState>((s) => s.auth);
  const userId = getRecordId(user);
  if (!Component) return null;

  return (
    <Route
      {...rest}
      sensitive
      render={(props) =>
        userId ? <Component {...props} /> : <Redirect to={{ pathname: "/signInPage" }} />
      }
    />
  );
};

/**
 * ConditionalAuthGuardRoute used for token-based authentication without login
 * @param props
 * @returns
 */
const ConditionalAuthGuardRoute: React.FC<RouteProps> = ({ component: Component, ...rest }) => {
  if (!Component) return null;

  return (
    <Route
      {...rest}
      sensitive
      render={(props) => <ConditionalAuthGuard {...props} children={<Component {...props} />} />}
    />
  );
};

const RevampRoutes = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const endSessionPaths = ["/", "/resmed", "/resmed/login", "/signInPage"];
  const endSession = endSessionPaths.some((path) => location.pathname === path);

  useEffect(() => {
    if (endSession) {
      AuthService.cleanAuth();
      dispatch(injectAuthUser({} as any));
    }
  }, [endSession, dispatch]);

  return (
    <>
      <HeaderBar />
      <Route exact sensitive path="/" component={Register} />
      <Route exact sensitive path="/scheduling" component={Register} />
      <Route exact sensitive path="/registration" component={Register} />

      <Route exact sensitive path="/resmed" component={Register} />
      <Route exact sensitive path="/resmed/login" component={ResmedSignIn} />

      <Route exact path="/signInPage" component={Login} />
      <Route exact path="/resetPasswordPage" component={PasswordReset} />
      <ProtectedRoute exact path="/patientDashboardPage" component={PatientDashboard} />
      <ProtectedRoute exact path="/complete-profile" component={CompleteProfile} />
      <Route exact path="/confirm-details" component={PatientDetailsPage} />

      {/* JWT-accessible routes */}
      <ConditionalAuthGuardRoute exact path="/forms" component={PatientFormPage} />
      <ConditionalAuthGuardRoute exact path="/forms/complete" component={FormCompletionPage} />
      <ConditionalAuthGuardRoute
        exact
        path="/moveUpAppointmentPage"
        component={MoveUpAppointmentPage}
      />
    </>
  );
};
export default RevampRoutes;
